module.exports = __webpack_public_path__ + "img/northgold_vit.bb20255c.svg";